import { AUTHORIZATION_API, DESIGN_SERVICE_API, SEALING_SERVER_API } from '@paragon/environment-tools';

import { ServerConnection } from './ServerConnection';

export const UserService = new ServerConnection(AUTHORIZATION_API);

const designService = new ServerConnection(DESIGN_SERVICE_API);
export const setDesignServerConnection = (designServerConnection: ServerConnection) => {
  DesignService = designServerConnection;
};
export const resetDesignServerConnection = () => {
  DesignService = designService;
};
export let DesignService = designService;
export const SealingService = new ServerConnection(SEALING_SERVER_API);
